import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const CLEAR_ALL_OUTPUTS = createAppSessionEventDefinition({
  type: "CLEAR_ALL_OUTPUTS",
  logSafe: {},
  create: () => ({}),
  apply: (previousState) => {
    previousState.outputs = {};
    previousState.outputContents = {};
  },
});
